import React from "react";
import { iconProps } from "../../../../Helper";

export const GenerateIllsturationsIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <mask
        id="mask0_12318_116461"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12318_116461)">
        <path
          className={className}
          d="M8.49967 11.0975C9.14323 11.0975 9.6994 10.8759 10.1682 10.4326C10.6371 9.98952 10.8886 9.44619 10.9227 8.80263H6.07017C6.1044 9.44619 6.35695 9.98952 6.82784 10.4326C7.29884 10.8759 7.85612 11.0975 8.49967 11.0975ZM5.35867 6.09114H7.76884C7.76884 5.75858 7.65006 5.47352 7.41251 5.23597C7.17484 4.9983 6.88979 4.87947 6.55734 4.87947C6.2249 4.87947 5.94201 4.9983 5.70867 5.23597C5.47534 5.47352 5.35867 5.75858 5.35867 6.09114ZM9.23051 6.08464H11.6407C11.6407 5.75219 11.523 5.46825 11.2875 5.2328C11.0521 4.99725 10.7681 4.87947 10.4355 4.87947C10.1031 4.87947 9.81912 4.99725 9.58367 5.2328C9.34823 5.46825 9.23051 5.75219 9.23051 6.08464ZM8.49967 14.3346C7.71334 14.3346 6.97662 14.1849 6.28951 13.8853C5.60229 13.5857 5.00312 13.1804 4.49201 12.6693C3.9809 12.1582 3.57662 11.5569 3.27917 10.8655C2.98173 10.1739 2.83301 9.43502 2.83301 8.6488V1.66797H14.1663V8.6488C14.1663 9.43502 14.0176 10.1739 13.7202 10.8655C13.4227 11.5569 13.0185 12.1582 12.5073 12.6693C11.9962 13.1804 11.3971 13.5857 10.7098 13.8853C10.0227 14.1849 9.28601 14.3346 8.49967 14.3346ZM8.49967 13.3346C9.78856 13.3346 10.8886 12.878 11.7997 11.9648C12.7108 11.0516 13.1663 9.94625 13.1663 8.6488V2.66797H3.83301V8.6488C3.83301 9.94625 4.28751 11.0516 5.19651 11.9648C6.10551 12.878 7.20656 13.3346 8.49967 13.3346Z"
        />
      </g>
    </svg>
  );
};
